import Vue from 'vue';
import Lib from '@/lib/lib';
import Define from '@/lib/define';
import Loader from '@/lib/axios';
import store from '@/store/index';
import router from '@/router';
import alertModal from '@/views/components/AlertModal';

const openPopup = (propsData = {
  cb_f: null,
  props_data: null,
}, popupVue) => {
  return new popupVue({
    el: document.createElement('div'),
    propsData,
    store,
    router,
  });
};

const popupOpen = (vue, f, d) => {
  const popupModal = openPopup({
    cb_f: (f) ? f : null,
    props_data: (d) ? d : null,
  }, Vue.extend(vue));
  popupModal.$children[0].active();
  return popupModal;
};

const openAlert = (propsData = {
  type: 'info',
  ok_cb: null,
  ng_cb: null,
  content: ''
}, alertVue) => {
  return new alertVue({
    el: document.createElement('div'),
    propsData,
    store,
    router,
  });
};

const alertOpen = (type, content, ok_cb, ng_cb) => {
  const AlertModal = openAlert({
    type: type,
    ok_cb: (ok_cb) ? ok_cb : null,
    ng_cb: (ng_cb) ? ng_cb : null,
    content: content
  }, Vue.extend(alertModal));
  AlertModal.active();
};

const dentalPlugin = {
  install: (Vue) => {
    Vue.prototype.$lib = Lib;
    Vue.prototype.$DF = Define;
    Vue.prototype.$loader = Loader;
    Vue.prototype.$popup = popupOpen;
    Vue.prototype.$alert = alertOpen;
  }
};

export default dentalPlugin;
